import { UseScheduleQualityScoreProvider } from 'components/widgets/ScheduleQualityScore/ScheduleQualityScore.provider';
import { getValueClassName } from 'components/widgets/ScheduleQualityScore/ScheduleQualityScore.utils';

interface Props {
    api: UseScheduleQualityScoreProvider['api'];
}

export const useScheduleQualityScoreLogic = ({ api }: Props) => {
    const value = api.getScheduleQualityScore.instance.data?.value;
    const threshold = api.getScheduleQualityScore.instance.data?.threshold;

    const calculatedValue = api.getScheduleQualityScore.instance.data?.value
        ? `${api.getScheduleQualityScore.instance.data?.value}%`
        : 'N/A';

    return {
        logic: {
            valueClassName: getValueClassName(value, threshold),
            calculatedValue,
        },
    };
};
